<nav class="device-subnav" fxLayout="column">
  <div>
    <h4
      [routerLink]="demo ? ['/demo/devices'] : ['/devices']"
      routerLinkActive="active-link"
      [routerLinkActiveOptions]="{ exact: true }"
      fxLayout
      fxLayoutAlign="start center"
      fxLayoutGap="10px">
      <ui-icon icon="griddy-wifi" [size]="20"></ui-icon>
      <span>Dashboard</span>
    </h4>
  </div>

  <div>
    <h4
      *ngIf="(hasWritePermission$ | async) === true"
      [routerLink]="['/devices/thermostat-presets']"
      routerLinkActive="active-link"
      fxLayout
      fxLayoutAlign="start center"
      fxLayoutGap="10px">
      <ui-icon icon="griddy-temperature" [size]="20"></ui-icon>
      <span>Thermostat presets</span>
    </h4>

    <h4
      [routerLink]="['/devices/setup']"
      routerLinkActive="active-link"
      fxLayout
      fxLayoutAlign="start center"
      fxLayoutGap="10px">
      <ui-icon icon="griddy-iot" [size]="20"></ui-icon>
      <span>Connect devices</span>
    </h4>

    <h4
      *ngIf="(hasWritePermission$ | async) === true"
      [routerLink]="['/devices/settings']"
      routerLinkActive="active-link"
      fxLayout
      fxLayoutAlign="start center"
      fxLayoutGap="10px">
      <ui-icon icon="cog" [size]="20"></ui-icon>
      <span>Settings</span>
    </h4>
  </div>
</nav>
